module.exports = __webpack_public_path__ + "../resources/img/bg_grid2_02.b48ec199.png";